.spinner {
  display: inline-block;
  width: var(--spinner-size);
  height: var(--spinner-size);
  border: 2px solid var(--cl-blue-gray-2);
  border-top-color: var(--cl-blue);
  border-radius: var(--cl-radius-round);
  animation: spin 0.8s linear infinite;
  flex: none;
}

.fullPage {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cl-bg-app);
  z-index: var(--cl-z-modal);
}

.skeleton {
  display: inline-block;
  border-radius: var(--cl-radius);
  background: linear-gradient(
    90deg,
    var(--cl-skeleton-bg) 25%,
    var(--cl-skeleton-shine) 50%,
    var(--cl-skeleton-bg) 75%
  );
  background-size: 200% 100%;
  animation: shine 1.4s ease infinite;
}

.circle {
  border-radius: var(--cl-radius-round);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes shine {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner,
  .skeleton {
    animation-duration: 3s;
  }
}
